import { render } from "./Tab6.vue?vue&type=template&id=00f58414&scoped=true"
import script from "./Tab6.vue?vue&type=script&lang=js"
export * from "./Tab6.vue?vue&type=script&lang=js"

import "./Tab6.vue?vue&type=style&index=0&id=00f58414&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f58414"]])

export default __exports__